import { render, staticRenderFns } from "./ChallengeEmail.vue?vue&type=template&id=20e9c0fe"
import script from "./ChallengeEmail.vue?vue&type=script&lang=js"
export * from "./ChallengeEmail.vue?vue&type=script&lang=js"
import style0 from "./ChallengeEmail.vue?vue&type=style&index=0&id=20e9c0fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports